export default "__VITE_ASSET__CfhlSy4D__"